<template>
  <div>
    <div class="no-events">
      <h6 class="font-weight-semi-bold m-0" v-translate>No events available</h6>
      <div class="message" v-translate>Create your first event now</div>
      <CButton @click.prevent="$emit('create')" color="primary" size="sm">
        <CIcon name="cip-plus" style="vertical-align: sub"/>
        <translate>New event</translate>
      </CButton>
    </div>
  </div>
</template>

<script>
export default {
  name: "WelcomeToPica",
  emit: ['create'],
}
</script>